<template>
  <div
    class="statisticsRows-ligne"
    @click="openRow"
    :class="{'is-radius-large' : !isTotal, 'is-opened': isOpen}">
    <div
      v-if="!isTotal"
      class="is-radius-top-left-large is-radius-top-right-large"
      :class="{ 'overDeco' : canOpen }"></div>
    <div class="columns is-gapless is-marginless">
      <div class="column columns is-2 is-vcentered">
        <div class="column is-narrow is-padding-left-small is-paddingless-right is-padding-top-small is-padding-bottom-small">
          <swatches
            class="colorPicker"
            v-if="!isTotal"
            v-model="color"
            @input="setColor"
            shapes="circles"
            :trigger-style="{width: '30px', height: '30px'}"
            :swatch-size="30"
            :colors="'material-basic'">
          </swatches>
        </div>
        <div class="column is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
          <strong class="entityName">{{ entity.name }}</strong><br>
          <span v-if="entity.subEntities && entity.subEntities.length">
            <span class="is-size-6">({{ entity.subEntities.length }} vendeurs)</span>
          </span>
        </div>
      </div>
      <div class="columns column is-6 is-vcentered">
        <div
          class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value
            v-if="!isTotal"
            :value="entity.prereservationsCount"></stat-value>
          <stat-value
            v-else
            :value="sales.pre_reserved"
            :total="true"></stat-value>
        </div>
        <div
          class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value
            v-if="!isTotal"
            :value="entity.reservationsCount"></stat-value>
          <stat-value
            v-else
            :value="sales.reserved"
            :total="true"></stat-value>
        </div>
        <div
          class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value
            v-if="!isTotal"
            :value="entity.actesCount"></stat-value>
          <stat-value
            v-else
            :value="sales.sold"
            :total="true"></stat-value>
        </div>
        <div
          class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value
            v-if="!isTotal"
            :value="entity.cancelCount"></stat-value>
          <stat-value
            v-else
            :value="sales.canceled"
            :total="true"></stat-value>
        </div>
        <div
          class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value
            v-if="!isTotal"
            :value="entity.CA_immo || entity.CA"
            :euro="true"></stat-value>
          <stat-value
            v-else
            :value="sales.CA_immo || sales.CA"
            :euro="true"
            :total="true"></stat-value>
        </div>
        <div
          class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value
            v-if="!isTotal"
            :value="entity.avgCA"
            :euro="true"></stat-value>
          <stat-value
            v-else
            :value="sales.avg_sale_price"
            :euro="true"
            :total="true"></stat-value>
        </div>
      </div>
      <div
        class="columns column is-4 is-vcentered is-border-left"
        :class="{'has-background-white is-radius-top-right-large is-radius-bottom-right-large': !isTotal}">
        <div
          class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value
            v-if="!isTotal"
            :value="entity.COM"
            :euro="true"></stat-value>
          <stat-value
            v-else
            :value="sales.seller_com"
            :euro="true"
            :total="true"></stat-value>
        </div>
        <div
          class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value
            v-if="!isTotal"
            :value="entity.avgCOM"
            :euro="true"></stat-value>
          <stat-value
            v-else
            :value="sales.avg_seller_sale_price"
            :euro="true"
            :total="true"></stat-value>
        </div>
        <div
          class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value
            v-if="!isTotal"
            :value="entity.avgRemuneration"
            :percentage="true"></stat-value>
          <stat-value
            v-else
            :value="sales.avg_seller_com"
            :percentage="true"
            :total="true"></stat-value>
        </div>
        <div class="column has-text-right is-2">
          <button
            v-if="!isTotal && canBeRemove"
            @click="remove"
            class="button is-circle is-small is-action">
            <i class="fal fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <div
      class="statisticsRows-detail is-size-6 is-border-top is-border--dashed"
      v-if="isOpen">
      <div
        v-for="(seller, i) in orderedSellers"
        class="columns is-gapless is-marginless"
        :key="'sellers' + i">
        <div class="column is-2">
          <div class="column is-paddingless-right is-padding-left-large is-padding-bottom-small is-padding-top-small ">
            <router-link :to="{name: 'UserVue', params: {id: seller.pk}}">
              <a class="is-margin-left is-padding-left">{{ seller.name }}<br></a>
            </router-link>
          </div>
        </div>
        <div class="columns column is-6">
          <div
            class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value
              :value="seller.prereservationsCount"
              :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value
              :value="seller.reservationsCount"
              :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value
              :value="seller.actesCount"
              :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value
              :value="seller.cancelCount"
              :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value
              :value="seller.CA_immo || seller.CA"
              :euro="true"
              :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value
              :value="seller.avgCA"
              :euro="true"
              :total="isTotal"></stat-value>
          </div>
        </div>
        <div class="columns column is-4 has-background-light is-radius-bottom-right-large">
          <div
            class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value
              :value="seller.COM"
              :euro="true"
              :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value
              :value="seller.avgCOM"
              :euro="true"
              :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value
              :value="seller.avgRemuneration"
              :percentage="true"
              :total="isTotal"></stat-value>
          </div>
          <div class="columns column is-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderBy } from 'lodash'
import randomcolor from 'randomcolor'
import { mapGetters } from 'vuex'

export default {
  name: 'StatsSellersRow',
  components: {
    Swatches: () => import('vue-swatches'),
    StatValue: () => import('@/components/statistics/StatValue')
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isTotal: {
      type: Boolean,
      default: false
    },
    canBeRemove: {
      type: Boolean,
      default: true
    },
    totalSubEntities: {
      type: Array
    },
    canOpenRow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      color: null
    }
  },
  computed: {
    ...mapGetters(['account']),
    sales () {
      if (this.isTotal) {
        return this.entity
      } else {
        return this.entity.items || []
      }
    },
    orderedSellers () {
      return orderBy(this.sellers, ['seller.first_name', 'seller.last_name'])
    },
    sellers () {
      if ('subEntities' in this.entity && this.entity.subEntities.length) {
        return this.entity.subEntities
      } else {
        return []
      }
    },
    canOpen () {
      if (this.orderedSellers && this.orderedSellers.length && (this.entity.name === this.account.name || this.canOpenRow)) return true
      return false
    }
  },
  created () {
    this.color = this.entity._color || randomcolor({ seed: this.entity.pk })
  },
  methods: {
    openRow () {
      if (this.canOpen) {
        this.$emit('open', this.entity)
      }
    },
    remove () {
      this.$emit('remove', this.entity)
    },
    setColor (value) {
      this.$emit('setColor', this.entity, value)
    }// ,
    // subEntityValues (seller, key) {
    //   if (this.totalSubEntities) {
    //     let result = this.totalSubEntities.find(x => x.pk === seller.pk)
    //     if (result) return result[key]
    //     else return 0
    //   } else return 0
    // }
  }
}
</script>
